export const environment = {
    production: true,
    apiUrl: '/api/',
    ta: false,
    taUrl: '//testmonkey.infoland.local/TAIntegration.js'
};
